module.exports = __webpack_public_path__ + "img/flat-screen-tv-1571458.21d688c6.jpg";